<div
  class="fixed inset-0 bg-[rgba(3,8,15,.6)] flex items-center justify-center z-[80]"
  (click)="alClicOverlay($event)"
  (keydown.escape)="cerrar.emit()"
  tabindex="-1"
>
  <div class="modal-card w-[440px] max-w-[92vw] rounded-2xl p-6">
    @if (estado() === 'seleccion') {
      <h3 class="text-base font-bold mb-1.5">Exportar a PowerPoint</h3>
      <p class="text-[12.5px] mb-4" style="color: var(--text-secondary)">
        Selecciona qué productos entran en la presentación. Se genera con el formato definido para la feria.
      </p>
      <input
        type="text"
        placeholder="Buscar por proveedor, mueble o nombre…"
        [value]="filtro()"
        (input)="alFiltrar($any($event.target).value)"
        class="field-input w-full text-[12.5px] px-3 py-2 mb-2.5 rounded-lg"
      />
      <div class="flex items-center justify-between mb-2.5">
        <span class="text-[11.5px]" style="color: var(--text-muted)">
          {{ seleccionados().size }} de {{ productos.length }} seleccionados
        </span>
        <label class="flex items-center gap-1.5 text-[11.5px] font-semibold cursor-pointer select-none">
          <input
            type="checkbox"
            [checked]="todosFiltradosSeleccionados"
            [indeterminate]="algunosFiltradosSeleccionados"
            (change)="alternarTodos()"
          />
          Seleccionar todos
        </label>
      </div>
      <div class="flex flex-col gap-2 mb-5 max-h-[280px] overflow-y-auto scroll-oscuro">
        @for (grupo of gruposFiltrados; track grupo.codigo) {
          <div class="rounded-lg" style="border: 1px solid var(--border)">
            <div
              class="grupo-row flex items-center gap-2.5 text-[12.5px] px-2.5 py-2 rounded-lg cursor-pointer"
              (click)="alternarExpandido(grupo.codigo)"
            >
              <input
                type="checkbox"
                [checked]="todosProductosDelGrupoSeleccionados(grupo)"
                [indeterminate]="algunosProductosDelGrupoSeleccionados(grupo)"
                (click)="$event.stopPropagation()"
                (change)="alternarGrupo(grupo)"
              />
              <span class="font-semibold">{{ grupo.etiqueta }}</span>
              <span class="ml-auto font-mono text-[10.5px]" style="color: var(--text-muted)">
                {{ contarSeleccionadosDelGrupo(grupo) }}/{{ grupo.productos.length }}
              </span>
              <span class="chevron text-[10px]" style="color: var(--text-muted)">{{ expandidos().has(grupo.codigo) ? '▾' : '▸' }}</span>
            </div>
            @if (expandidos().has(grupo.codigo)) {
              <div class="flex flex-col gap-1 pl-7 pb-2 pr-2.5">
                @for (p of grupo.productos; track p.id) {
                  <label [attr.for]="'export-producto-' + p.id" class="item-row flex items-center gap-2.5 text-[12.5px] px-2.5 py-2 rounded-lg">
                    <input [id]="'export-producto-' + p.id" type="checkbox" [checked]="seleccionados().has(p.id)" (change)="alternar(p.id)" />
                    <span class="font-semibold">{{ p.mueble }}</span>
                    <span class="ml-auto font-mono text-[10.5px]" style="color: var(--text-muted)">{{ p.id }}</span>
                  </label>
                }
              </div>
            }
          </div>
        } @empty {
          <p class="text-[12.5px] text-center py-4" style="color: var(--text-muted)">Sin resultados para "{{ filtro() }}".</p>
        }
      </div>
      <div class="flex justify-end gap-2.5">
        <button (click)="cerrar.emit()" class="btn-ghost text-[13px] font-semibold px-4 py-2 rounded-lg">
          Cancelar
        </button>
        <button (click)="generar()" [disabled]="seleccionados().size === 0"
                class="btn-primary text-[13px] font-semibold px-4 py-2 rounded-lg">
          Generar presentación
        </button>
      </div>
    }

    @if (estado() === 'generando') {
      <h3 class="text-base font-bold mb-1.5">Generando presentación…</h3>
      <div class="flex items-center gap-2.5 text-[12.5px]" style="color: var(--text-secondary)">
        <span class="w-[15px] h-[15px] rounded-full border-2 animate-spin" style="border-color: var(--border); border-top-color: var(--jamar-red)"></span>
        Leyendo {{ seleccionados().size }} producto(s) y sus fichas de tela
      </div>
    }

    @if (estado() === 'listo') {
      <h3 class="text-base font-bold mb-1.5">Presentación lista</h3>
      <p class="text-[12.5px] mb-4" style="color: var(--text-secondary)">
        Se descargó <b>Feria_China_2026.pptx</b> con foto + color + FOB + rango, uno por producto seleccionado.
      </p>
      <button (click)="cerrar.emit()" class="btn-primary text-[13px] font-semibold px-4 py-2 rounded-lg">Cerrar</button>
    }

    @if (estado() === 'error') {
      <h3 class="error-title text-base font-bold mb-1.5">No se pudo generar</h3>
      <p class="text-[12.5px] mb-4" style="color: var(--text-secondary)">
        {{ mensajeError() }}.
      </p>
      <button (click)="reintentar()" class="btn-ghost text-[13px] font-semibold px-4 py-2 rounded-lg">
        Volver a intentar
      </button>
    }
  </div>
</div>
